export default [
  {
    path: '/config/smtp',
    name: 'Smtp',
    component: () => import('@/views/Smtp/Index.vue'),
    meta: {
      pageTitle: 'Ayarlar',
      breadcrumb: [
        {
          text: 'SMTP Yapılandırma',
          active: true,
        },
      ],
      resource: 'ADMIN_SMTP_CONFIG',
      action: 'read',
    },
  },
]
